<template>
  <div class="containerFull">
    <!--     <Jumbotron
      urlImage="../../assets/layout/images/fondo_banner.png"
      title="Quality & Care"
      subtitle="El centro de cirugía ambulatoria que le brinda la mejor experiencia medico - paciente."
      :showBoton="true"
    /> -->
    <SlideImages />
    <!-- <InfoCircles /> -->
    <HorizontalInfoCircles />
    <GaleriaMain />
    <Kpis />
    <MediosDePago />
    <ComoSerParte />
    <Blog />
    <TestimonialesSlider />
    <Convenios />
  </div>
</template>

<script>
/* import Jumbotron from "./layout/jumbotron_main.vue"; */
import HorizontalInfoCircles from "./layout/horizontal_info_circles_main.vue";
import GaleriaMain from "./layout/galeria_main.vue";
import Kpis from "./layout/kpis.vue";
import ComoSerParte from "./layout/como_ser_parte.vue";
import Blog from "./blog.vue";
import TestimonialesSlider from "./layout/testimoniales_slider.vue";
import SlideImages from "./slide_images.vue";
import MediosDePago from "./medios_de_pago.vue";
import Convenios from "./convenios.vue";
export default {
  components: {
    /* Jumbotron, */
    HorizontalInfoCircles,
    GaleriaMain,
    Kpis,
    ComoSerParte,
    Blog,
    TestimonialesSlider,
    SlideImages,
    MediosDePago,
    Convenios
  }
};
</script>
